// Copyright (C) 2022 by Posit Software, PBC.

export function truncate(text, max) {
  text = text.toString();
  if (text.length > max) {
    text = `${text.substring(0, max)}...`;
  }
  return text;
}
